export default {"src":"/_next/static/media/sngls.83098dd9.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};